import frFR from 'antd/lib/locale/fr_FR';

import { RecuperationActiviteUtilisateurRequestDto } from 'lib_api/lib/api/gen';

import { RecuperationActiviteUtilisateurFormValues } from './types';

export function mapRecuperationActiviteUtilisateurFormValuesToRequest(
  values: RecuperationActiviteUtilisateurFormValues,
): RecuperationActiviteUtilisateurRequestDto {
  return {
    id: values.id ?? null,
    nom: values.nom ?? null,
    prenom: values.prenom ?? null,
    dateDebut:
      values.dateDebut?.utcOffset(frFR.locale).startOf('day').toISOString() ??
      null,
    dateFin:
      values.dateFin?.utcOffset(frFR.locale).endOf('day').toISOString() ?? null,
  };
}
